import { MessageCircle } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { waLink } from "../lib/site";

export const StickyCta = () => {
  const { t } = useLang();
  return (
    <div
      data-testid="sticky-mobile-cta"
      className="fixed inset-x-0 bottom-0 z-40 border-t border-black/10 bg-white/95 px-4 py-3 backdrop-blur lg:hidden"
      style={{ paddingBottom: "max(0.75rem, env(safe-area-inset-bottom))" }}
    >
      <a
        href={waLink(t.hero.waMsg)}
        target="_blank"
        rel="noreferrer"
        data-testid="sticky-talk-cta"
        className="flex w-full items-center justify-center gap-2 rounded-xl bg-sinovar-blue px-6 py-3.5 text-[15px] font-semibold text-white"
      >
        <MessageCircle className="h-5 w-5" />
        {t.nav.talk}
      </a>
    </div>
  );
};
